import { buildUrl } from "../../../helpers/apiHelper";
import axios from "../../../lib/axios"

const getForecastCalculationBasis = async (
    config,
    options = {
        with: [],
        where: {}
    }
) => {
    const baseUrl = '/api/forecast-calculation-basis';

    return await axios
        .get(buildUrl(baseUrl, options), config)
        .then(({ data }) => data?.data ?? [])
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const forecastCalculationBasisAPI = {
    getForecastCalculationBasis
}

export default forecastCalculationBasisAPI
